<div class="vehicles-container mat-elevation-z2">
  <div class="table-header">
    <div class="header-top">
      <h2>Vehicle Management</h2>
      <div class="actions">
        <button mat-flat-button color="primary" (click)="openCreateDialog()">Add Vehicle</button>
      </div>
    </div>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Vehicles</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search by plate, model, or rider..." />
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="analytics-grid" *ngIf="analytics">
    <div class="stat-card">
      <div class="title">Work Date</div>
      <div class="value">{{ analytics.workDate | date:'mediumDate' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Opened Today</div>
      <div class="value">{{ analytics.openedCount }}/{{ analytics.totalVehicles }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Closed Today</div>
      <div class="value">{{ analytics.closedCount }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Pending Close</div>
      <div class="value warn">{{ analytics.pendingCloseCount }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Total Distance</div>
      <div class="value">{{ analytics.totalDistance | number:'1.0-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Average Distance</div>
      <div class="value">{{ analytics.averageDistance | number:'1.0-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Avg Start Fuel (%)</div>
      <div class="value">{{ analytics.averageStartFuelLevel | number:'1.0-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Avg End Fuel (%)</div>
      <div class="value">{{ analytics.averageEndFuelLevel | number:'1.0-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="title">Avg Fuel Used (%)</div>
      <div class="value">{{ analytics.averageFuelUsed | number:'1.0-2' }}</div>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 full-width-table">
    <ng-container matColumnDef="plateNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Plate Number</th>
      <td mat-cell *matCellDef="let v">{{ v.plateNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Model</th>
      <td mat-cell *matCellDef="let v">{{ v.model }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let v">{{ v.type }}</td>
    </ng-container>

    <ng-container matColumnDef="capacity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Capacity</th>
      <td mat-cell *matCellDef="let v">{{ v.capacity }}</td>
    </ng-container>

    <ng-container matColumnDef="riderName">
      <th mat-header-cell *matHeaderCellDef>Assigned Rider</th>
      <td mat-cell *matCellDef="let v">{{ v.riderName || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="startMeter">
      <th mat-header-cell *matHeaderCellDef>Start Meter</th>
      <td mat-cell *matCellDef="let v">{{ v.startMeter ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="startFuelLevel">
      <th mat-header-cell *matHeaderCellDef>Start Fuel %</th>
      <td mat-cell *matCellDef="let v">{{ v.startFuelLevel ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="endMeter">
      <th mat-header-cell *matHeaderCellDef>End Meter</th>
      <td mat-cell *matCellDef="let v">{{ v.endMeter ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="endFuelLevel">
      <th mat-header-cell *matHeaderCellDef>End Fuel %</th>
      <td mat-cell *matCellDef="let v">{{ v.endFuelLevel ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="fuelUsed">
      <th mat-header-cell *matHeaderCellDef>Fuel Used %</th>
      <td mat-cell *matCellDef="let v">{{ v.fuelUsed ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="distanceToday">
      <th mat-header-cell *matHeaderCellDef>Distance Today</th>
      <td mat-cell *matCellDef="let v">{{ v.distanceToday ?? '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let v">
        <span class="chip" [ngClass]="v.isActive ? 'active' : 'inactive'">
          {{ v.isActive ? 'Active' : 'Inactive' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="meterActions">
      <th mat-header-cell *matHeaderCellDef>Work Meter</th>
      <td mat-cell *matCellDef="let v">
        <button mat-icon-button [matMenuTriggerFor]="meterMenu" matTooltip="Work Meter Actions">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #meterMenu="matMenu">
          <button mat-menu-item (click)="openWork(v)" [disabled]="!!v.startMeter">
            <mat-icon>play_circle</mat-icon>
            <span>Open Work</span>
          </button>
          <button mat-menu-item (click)="closeWork(v)" [disabled]="!v.startMeter || !!v.endMeter">
            <mat-icon>stop_circle</mat-icon>
            <span>Close Work</span>
          </button>
          <button mat-menu-item (click)="editMeter(v)" [disabled]="!v.meterLogId || !v.canEditMeter">
            <mat-icon>edit</mat-icon>
            <span>Edit Entry</span>
          </button>
        </mat-menu>
        <div class="edit-note" *ngIf="v.meterLogId && !v.canEditMeter">Edit locked after 15 min</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let v">
        <button mat-icon-button [matMenuTriggerFor]="vehicleActionMenu" matTooltip="Vehicle Actions">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #vehicleActionMenu="matMenu">
          <button mat-menu-item (click)="openEditDialog(v)">
            <mat-icon>edit</mat-icon>
            <span>Edit Vehicle</span>
          </button>
          <button mat-menu-item (click)="openAssignDialog(v)">
            <mat-icon>person_add</mat-icon>
            <span>Assign Rider</span>
          </button>
          <button mat-menu-item (click)="deleteVehicle(v)">
            <mat-icon>delete</mat-icon>
            <span>Delete Vehicle</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
</div>
